module.exports = __webpack_public_path__ + "img/red-x.378303e9.svg";